import { render, staticRenderFns } from "./ForgotPassword.vue?vue&type=template&id=5b071cfc&scoped=true"
import script from "./ForgotPassword.vue?vue&type=script&lang=ts"
export * from "./ForgotPassword.vue?vue&type=script&lang=ts"
import style0 from "./ForgotPassword.vue?vue&type=style&index=0&id=5b071cfc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b071cfc",
  null
  
)

export default component.exports